import './locales/register'
import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { RouteObject } from 'react-router-dom'

const ReportWAFList = lazy(() => import('./components/List'))
const ReportWafCreate = lazy(() => import('./components/New'))
const ReportWafUpdate = lazy(() => import('./components/Update'))
const ReportWafHistory = lazy(() => import('./components/History'))
const PipelineDashboard = lazy(() => import('./components/Pipeline'))

const ReportWAFModule: RouteObject = {
    path: 'technical/report',
    children: [
        {
            path: '',
            element: <ReportWAFList />,
        },
        {
            path: 'pipeline',
            element: <PipelineDashboard />,
        },
        {
            path: 'new',
            element: <ReportWafCreate />,
        },
        {
            path: ':id/edit',
            element: <ReportWafUpdate />,
        },
        {
            path: ':id/history',
            element: <ReportWafHistory />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ReportWAFModule
